import React, { createContext, useContext, useState, useEffect } from 'react';

const WelcomeContext = createContext();

export function useWelcome() {
  return useContext(WelcomeContext);
}

export function WelcomeProvider({ children }) {
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    // Only show welcome modal in non-Electron environments (web app)
    const isElectron = import.meta.env.VITE_ELECTRON === 'true';
    const hasSeenWelcome = localStorage.getItem('sonicGroove_hasSeenWelcome');
    
    if (!isElectron && !hasSeenWelcome) {
      // Small delay to ensure app is fully loaded
      const timer = setTimeout(() => {
        setShowWelcome(true);
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleCloseWelcome = () => {
    setShowWelcome(false);
    localStorage.setItem('sonicGroove_hasSeenWelcome', 'true');
  };

  const resetWelcome = () => {
    localStorage.removeItem('sonicGroove_hasSeenWelcome');
    setShowWelcome(true);
  };

  const contextValue = {
    showWelcome,
    closeWelcome: handleCloseWelcome,
    resetWelcome,
  };

  return (
    <WelcomeContext.Provider value={contextValue}>
      {children}
    </WelcomeContext.Provider>
  );
}
